<template>
  <div id="costs">
    <v-layout row wrap class="ma-1">
      <v-flex>
        <v-tooltip bottom>
          <template v-slot:activator="{ on }"> 
            <v-btn depressed block @click="$emit('update-visibility')" v-on="cost.description ? on : null">
              <v-icon v-if="cost.verified" color="blue lighten-1">check_circle</v-icon>
              {{ cost.name }}
            </v-btn>
          </template>
          <span>{{ cost.description }}</span>
        </v-tooltip>
      </v-flex>
      <v-flex shrink>
        <v-btn icon @click="flipEditing" class="ml-1">
          <v-icon :color="editColor">{{ editIcon }}</v-icon>
        </v-btn>
        <v-btn @click="$emit('delete-cost')" icon class="ml-1">
          <v-icon color="red lighten-1">fas fa-minus-circle</v-icon>
        </v-btn>
      </v-flex>
    </v-layout>

    <v-layout
      row
      wrap
      justify-space-around
      v-if="cost.visible"
    >
      <v-flex
        class="cell pa-3"
        v-for="(subCost, i) in cost.subCosts"
        :key="i"
        xs6 sm4
      >
        <v-text-field
          v-if="editValues"
          :label="subCost.name"
          v-model="subCost.value"
          type="number"
          min="0"
        ></v-text-field>
        <v-text-field
          v-if="!editValues"
          :label="subCost.value"
          v-model="subCost.name"
          min="0"
        ></v-text-field>
      </v-flex>
    </v-layout>
  </div>
</template>

<script>
export default {
  name: "costs",
  props: {
    cost: {
      type: Object,
      default: () => {},
    },
  },
  data() {
		return {
      editValues: true,
    };
  },
  computed: {
    editIcon() {
      return this.editValues ? "fas fa-pencil-alt" : "fas fa-pencil-alt fa-flip-horizontal";
    },
    editColor() {
      return this.editValues ? "blue lighten-1" : "green lighten-1";
    },
  },
  methods: {
    flipEditing() {
      this.editValues = !this.editValues;
    },
    deleteDescription() {
      this.cost.description = null;
    },
  },
};
</script>
